import {useState} from "react";
import {ChromePicker} from "react-color";
import styles from "./index.module.scss";

// the only characters the user is allowed to enter in numeric input fields
const decimalChars = '.-0123456789';
const allowedKeys = ['ArrowLeft', 'ArrowRight', 'Backspace'];

const NumberInput = ({name, value, step, inputOnChange}) => {
  let title = "";
  if (name === "FogDensity") title = "Density";
  else if (name === "FogNear") title = "Near";
  else if (name === "FogFar") title = "Far";
  else if (name === "ssaoIntensity" || name === "bloomIntensity") title = "intensity";
  else if (name === "godraysDensity") title = "density";
  else if (name === "godraysWeight") title = "weight";
  else if (name === "HSVopacity" || name === "BCopacity" || name === "bloomOpacity") title = "opacity";
  else if (name === "CameraDepth") title = "Depth";
  else title = name;

  return (
    <div className={styles.container}>
      <p className={styles.title}>{title}</p>
      <div className={styles.wrapper}>
        <input
          className={styles.number_input}
          type="text"     // previously: type="number"
          name={name}
          step={step}
          value={value}
          onChange={e => inputOnChange(name, e.target.value, e)}    
          onKeyDown={e => {
            if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
              e.preventDefault();
            }
          }}    
        />
      </div>
    </div>
  );
};

const NumberSliderInput = ({name, value, inputOnChange, min, max, step = 0.1, depth}) => {
  let title = "";
  if (name === "FogDensity") title = "Density";
  else if (name === "FogNear" || name === "CameraNear") title = "Near";
  else if (name === "FogFar" || name === "CameraFar") title = "Far";
  else if (name === "SSAOIntensity" || name === "BloomIntensity") title = "Intensity";
  else if (name === "GodraysDensity") title = "Density";
  else if (name === "GodraysWeight") title = "Weight";
  else if (name === "HSVOpacity" || name === "BCOpacity" || name === "BloomOpacity") title = "Opacity";
  else if (name === "BloomRadius") title = "Radius";
  else if (name === "LuminanceThreshold") title = "Threshold";
  else if (name === "LuminanceSmoothing") title = "Smoothing";
  else if (name === "BCBrightness") title = "Brightness";
  else if (name === "BCContrast") title = "Contrast";
  else if (name === "CameraFov") title = "Fov";
  else if (name === "CameraLeft") title = "Left";
  else if (name === "CameraRight") title = "Right";
  else if (name === "CameraTop") title = "Top";
  else if (name === "CameraBottom") title = "Bottom";
  else title = name;

  if (depth === 2)
    return (
      <NumberSliderVerticalInput name={name} value={value} inputOnChange={inputOnChange} min={min} max={max} step={step} title={title} />
    );

  return (
    <div className={`${styles.container} ${depth === 1 ? styles.depth_1 : ""}`}>
      <p className={styles.title}>{title}</p>
      <input
        className={styles.number_input}
        type="text"
        name={name}
        step={step}
        value={value}
        onChange={e => inputOnChange(name, e.target.value, e)}    
        onKeyDown={e => {
          if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
            e.preventDefault();
          }
        }}
      />
      <input
        id={`range_${title}`}
        className={styles.range_input}
        type="range"
        min={min}
        max={max}
        step={step}
        value={value}
        onChange={e => inputOnChange(name, e.target.value, e)}
      />
    </div>
  );
};

const NumberSliderVerticalInput = ({name, value, inputOnChange, min, max, step, title}) => {
  return (
    <div className={`${styles.container} ${styles.depth_2}`}>
      <p className={styles.title}>{title}</p>
      <div className={styles.vertical}>
        <input
          className={styles.number_input}
          type="text"
          name={name}
          step={step}
          value={value}
          onChange={e => inputOnChange(name, e.target.value, e)}
          onKeyDown={e => {
            if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
              e.preventDefault();
            }
          }}
        />
        <input
          id={`range_${title}`}
          className={styles.range_input}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={e => inputOnChange(name, e.target.value, e)}
        />
      </div>
    </div>
  );
};

const NumberColorInput = ({name, value, inputOnChange, min, max, step = 0.1, objectColor, colorOnChange}) => {
  const [colorBoxOn, setColorBoxOn] = useState(false);

  const onClickColorBox = () => {
    setColorBoxOn(!colorBoxOn);
  };

  return (
    <div className={styles.container_NCI}>
      <div className={styles.color_wrapper}>
        <p className={styles.title}>{name}</p>
        <input
          className={styles.number_input}
          type="text"
          name={name}
          step={step}
          value={value}
          onChange={e => inputOnChange(name, e.target.value, e)}
          onKeyDown={e => {
            if (!(decimalChars.includes(e.key)) && !(allowedKeys.includes(e.key))) {
              e.preventDefault();
            }
          }}
        />
        <div className={styles.color_box} onClick={onClickColorBox} style={{background: objectColor}} />
        {colorBoxOn && (
          <div className={styles.color_picker}>
            <div onClick={onClickColorBox} className={styles.close_button} />
            <ChromePicker color={objectColor} onChange={e => colorOnChange(name, e)} />
          </div>
        )}
      </div>

      <div className={styles.wrapper_NCI}>
        <input
          className={styles.range_input}
          type="range"
          min={min}
          max={max}
          step={step}
          value={value}
          onChange={e => inputOnChange(name, e.target.value, e)}
        />
      </div>
    </div>
  );
};

export {NumberInput, NumberSliderInput, NumberColorInput};
